import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import { fetchMembers }     from "Actions/Admin/Strech/MemberActions";
import Common               from "Utils/Common";
import Href                 from "dashboard/dist/Core/Href";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import Main                 from "dashboard/dist/Components/Main";
import Header               from "dashboard/dist/Components/Header";
import Content              from "dashboard/dist/Components/Content";
import Table                from "dashboard/dist/Components/Table";
import TableHead            from "dashboard/dist/Components/TableHead";
import TableBody            from "dashboard/dist/Components/TableBody";
import TableRow             from "dashboard/dist/Components/TableRow";
import TableHeader          from "dashboard/dist/Components/TableHeader";
import TableCell            from "dashboard/dist/Components/TableCell";
import TablePaging          from "dashboard/dist/Components/TablePaging";
import TableActionList      from "dashboard/dist/Components/TableActionList";
import TableAction          from "dashboard/dist/Components/TableAction";



/**
 * The Member List
 */
class MemberList extends React.Component {
    /**
     * Load the Data
     * @returns {Void}
     */
    componentDidMount() {
        this.fetch();
    }

    /**
     * Fetch the content
     * @param {Object=} params
     * @returns {Void}
     */
    fetch = (params) => {
        const { type, elemID, data } = this.props;
        this.props.fetchMembers(type, elemID, params || data.sort);
    }



    /**
     * Starts an Action
     * @param {Object} action
     * @param {Number} elemID
     * @returns {Void}
     */
    startAction = (action, elemID) => {
        if (action.isStudent) {
            const member = Utils.getValue(this.props.data.list, "credentialID", elemID);
            Href.goto(Common.getAccessBaseUrl(member), member.credentialID);
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { data, route                         } = this.props;
        const { canEdit, list, total, sort, loading } = data;

        return <Main>
            <Header message="STUDENTS_NAME" icon="student" route={route} />
            <Content isLoading={loading}>
                <Table fetch={this.fetch} sort={sort} none="STUDENTS_NONE_AVAILABLE">
                    <TableHead>
                        <TableHeader field="firstName" message="GENERAL_NAME"    hideCircle={!canEdit} />
                        <TableHeader field="email"     message="GENERAL_EMAIL"   />
                        <TableHeader field="cellphone" message="USERS_CELLPHONE" />
                    </TableHead>
                    <TableBody>
                        {list.map((elem) => <TableRow key={elem.credentialID} elemID={elem.credentialID}>
                            <TableCell message={elem.credentialName} circle={elem.statusColor} />
                            <TableCell message={elem.email}          />
                            <TableCell message={elem.phoneString}    />
                        </TableRow>)}
                    </TableBody>
                    <TablePaging total={total} />
                    <TableActionList onAction={this.startAction} canEdit={canEdit}>
                        <TableAction action="STUDENT" message="STUDENTS_VIEW_TITLE" isHidden={!canEdit} />
                    </TableActionList>
                </Table>
            </Content>
        </Main>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchMembers : PropTypes.func.isRequired,
        data         : PropTypes.object.isRequired,
        route        : PropTypes.string.isRequired,
        type         : PropTypes.string.isRequired,
        elemID       : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            data : state.groupMember,
        };
    }
}

export default connect(MemberList.mapStateToProps, {
    fetchMembers,
})(MemberList);
